import styled from 'styled-components'

export const Wrapper = styled.div`
    /* scroll-snap-type: y mandatory;
    overflow-y: scroll; */
    /* width: 100vw; */
    height: 100vh;
`

export const Section = styled.div`
    display: flex;
    height: 100vh;
    width: 100%;
    background-color: #EEC2F5;
    /* scroll-snap-align: start; */
`

export const Container = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media screen and (max-width: 768px) {
        flex-direction: column;
    }
`;

export const Opening = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    color: #CE1212;
    font-size: 5rem;
    margin: 0px 0px 100px 0px;
    @media screen and (max-width: 768px) {
        font-size: 3.3rem;
    }
`
export const Frag = styled.div`
    display: flex;
    flex-direction: row;
    width: 50%;
    @media screen and (max-width: 768px) {
        margin-top: 30px;
        width: 100%;
    }
`
export const ImgCon = styled.div`
    margin: 100px 50px;
    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const Title = styled.h1`
    font-size: 4.5rem;
    @media screen and (max-width: 768px) {
        font-size: 4.2rem;
    }
`
export const Sub = styled.p`
    font-size: 1.5rem;
    padding-top: 20px;
    font-weight: 100;
    @media screen and (max-width: 768px) {
        font-size: 1.8rem;
    }
`
export const ColL = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 85px 0 20px 70px;
    @media screen and (max-width: 768px) {
        margin: 85px 30px 20px 20px;
    }
`
export const ColR = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 85px 70px 20px 0;
    @media screen and (max-width: 768px) {
        margin: 85px 20px 20px 30px;
    }
`
export const Num = styled.p`
    font-weight: 900;
    font-size: 10rem;
    opacity: 60%;
    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const TagConL = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 0.8rem;
`
export const TagConR = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-end;
    font-size: 0.8rem;
`

export const Tag = styled.p`
    margin: 8px 5px;
    padding: 8px 15px;
    border-radius: 30px;
    background-color: #333333;
    color: #FFF;
    font-weight: bold;
`
export const Button = styled.a`
    padding: 8px;
    margin-top: 20px;
    color: #333;
    font-size: 1.2rem;
    font-weight: 500;
    /* border: 1px solid; */
    width: 150px;
    text-align: center;
    display: flex;
    justify-content: center;
    cursor: pointer;
    text-decoration: none;
    &:hover{
        background-color: #fff;
        color: #333;
        transition: all 0.2s ease;
    }
    @media screen and (max-width: 768px){
        padding: 20px 20px;
        margin-top: 40px;
    }
`

